module.exports = "/_next/static/images/background-f7f72a138ad5a8aa56c644c105a65966.jpg";